let analyticsServiceUrl = process.env.NEXT_PUBLIC_ANALYTICS_SERVICE_URL;
let apiHost = process.env.NEXT_PUBLIC_API_HOST;
let baseName = process.env.NEXT_PUBLIC_BASE_NAME;
let brandingServicePluginUrl = process.env.NEXT_PUBLIC_BRANDING_SERVICE_PLUGIN_URL;
let footerServicePluginUrl = process.env.NEXT_PUBLIC_FOOTER_SERVICE_PLUGIN_URL;
let gqlHost = process.env.NEXT_PUBLIC_GRAPHQL_HOST;
let pod = process.env.NEXT_PUBLIC_POD;
let publicPath = process.env.NEXT_PUBLIC_PUBLIC_PATH;
let subscriptionsInlineLoginPluginUrl = process.env.NEXT_PUBLIC_SUBSCRIPTIONS_INLINE_LOGIN_PLUGIN_URL;
let edailyNewsletterFormId = process.env.NEXT_PUBLIC_EDAILY_NEWSLETTER_FORM_ID;
let salesForceProxyApiUrl = process.env.NEXT_PUBLIC_COMMON_SALESFORCE_PROXY_API_URL;
let defaultGeoLocationID = process.env.NEXT_PUBLIC_DEFAULT_GEO_LOCATION_ID;
let robotsNoIndex = process.env.NEXT_PUBLIC_ROBOTS_NOINDEX === 'true';
let publicSiteUrl = process.env.NEXT_PUBLIC_PUBLIC_SITE_URL;
let sfmcProPlusFormId = process.env.NEXT_PUBLIC_SFMC_PRO_PLUS_INQUIRY_FORM_ID;
if (!sfmcProPlusFormId) {
  sfmcProPlusFormId = '7452';
}
sfmcProPlusFormId = parseInt(sfmcProPlusFormId);

const articlesServiceUrl = process.env.NEXT_PUBLIC_ARTICLES_SERVICE_URL;
const typeaheadPluginUrl = process.env.NEXT_PUBLIC_TYPEAHEAD_PLUGIN_URL;
const noteworthyContentService = process.env.NEXT_PUBLIC_NOTEWORTHY_CONTENT_SERVICE;
const noteworthyContentApi = process.env.NEXT_PUBLIC_NOTEWORTHY_CONTENT_API_URL;
const researchTopicsServiceUrl = process.env.NEXT_PUBLIC_RESEARCH_TOPICS_SERVICE_URL;
const searchServiceUrl = process.env.NEXT_PUBLIC_SEARCH_SERVICE_URL;
const forecastsServiceUrl = process.env.NEXT_PUBLIC_FORECASTS_SERVICE_URL;
const forecastsSubscriptionServiceUrl = process.env.NEXT_PUBLIC_FORECASTS_SUBSCRIPTION_SERVICE_URL;

const subscriptionsLoginUrl = process.env.NEXT_PUBLIC_SUBSCRIPTIONS_LOGIN_URL;
const podRedirectionServiceUrl = `${subscriptionsLoginUrl}/IIPodRedirection/?pod=&url=`;
const contentUrl = process.env.NEXT_PUBLIC_CONTENT_URL;
const iiHomeUrl = process.env.NEXT_PUBLIC_HOME_URL;
const osanoScriptUrl = process.env.NEXT_PUBLIC_OSANO_SCRIPT_URL;
const doesmyCompanyPluginUrl = process.env.NEXT_PUBLIC_SUBSCRIPTIONS_DOES_MY_COMPANY_SUBSCRIBE_PLUGIN_URL;
const currentEnvironment = process.env.NEXT_PUBLIC_CURRENT_ENVIRONMENT;

const gaApiSecret = process.env.NEXT_PUBLIC_GA_API_SECRET;
const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
const osfScriptUrl = process.env.COMMON_OSF_SCRIPT_URL;

const gamGptScriptUrl = process.env.NEXT_PUBLIC_GAM_GPT_SCRIPT_URL;
const gamNetworkId = process.env.NEXT_PUBLIC_GAM_NETWORK_ID;
const gamParentAdUnitId = process.env.NEXT_PUBLIC_GAM_PARENT_AD_UNIT_ID;
const gamCurrentMicroserviceS1Id = process.env.NEXT_PUBLIC_GAM_CURRENT_MICROSERVICE_S1_ID;
const gamTestAdContainerId = process.env.NEXT_PUBLIC_GAM_TEST_AD_CONTAINER_ID;

const userEmailDomainCookieKey = process.env.NEXT_PUBLIC_USER_EMAILDOMAIN_COOKIE;
const ctaPrivacyUrl = process.env.NEXT_PUBLIC_CTA_PRIVACY_URL;
const ctaTermsUrl = process.env.NEXT_PUBLIC_CTA_TERMS_URL;

const applicationReleaseNumber = process.env.NEXT_PUBLIC_DD_VERSION;
const serviceName = process.env.NEXT_PUBLIC_DD_SERVICE;
const environment = process.env.NEXT_PUBLIC_DD_ENV;
const dataDogBrowserSampleRate = isNaN(process.env.NEXT_PUBLIC_DD_BROWSER_SAMPLE_RATE)
  ? 0
  : Number(process.env.NEXT_PUBLIC_DD_BROWSER_SAMPLE_RATE);
const dataDogTraceSampleRate = isNaN(process.env.NEXT_PUBLIC_DD_TRACE_SAMPLE_RATE)
  ? 0
  : Number(process.env.NEXT_PUBLIC_DD_TRACE_SAMPLE_RATE);
const dataDogApplicationId = process.env.NEXT_PUBLIC_DD_APPLICATION_ID;
const dataDogClientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
const dataDogEnabled = process.env.NEXT_PUBLIC_DD_ENABLED;
const dataDogAllowedTracingOrigin = process.env.NEXT_PUBLIC_DD_ALLOWED_TRACING_ORIGIN;
const nonPremiumFeatures = process.env.NEXT_PUBLIC_PREMIUM_FORECASTS_ENABLE_NONPREMIUM;
const enableNonPremiumFeatures = nonPremiumFeatures.toString() === 'true';

const debugVersion = process.env.NEXT_PUBLIC_DEBUG_VERSION;

const ldJsonLogoUrl = process.env.NEXT_PUBLIC_COMMON_LD_JSON_LOGO_URL;
const fontCSSUrl = process.env.NEXT_PUBLIC_COMMON_FONTS_CSS_URL;
const defaultShareUrl = process.env.NEXT_PUBLIC_COMMON_DEFAULT_SOCIAL_THUMBNAIL_URL;

const config = {
  host: 'localhost',
  port: 8080,
  analyticsServiceUrl,
  apiHost,
  baseName,
  brandingServicePluginUrl,
  footerServicePluginUrl,
  gqlHost,
  pod,
  publicPath,
  subscriptionsInlineLoginPluginUrl,
  edailyNewsletterFormId,
  salesForceProxyApiUrl,
  defaultGeoLocationID,
  robotsNoIndex,
  publicSiteUrl,
  articlesServiceUrl,
  typeaheadPluginUrl,
  noteworthyContentService,
  noteworthyContentApi,
  researchTopicsServiceUrl,
  searchServiceUrl,

  forecastsServiceUrl,
  forecastsSubscriptionServiceUrl,

  subscriptionsLoginUrl,
  podRedirectionServiceUrl,
  osanoScriptUrl,
  gaApiSecret,
  gaMeasurementId,
  contentUrl,
  iiHomeUrl,
  doesmyCompanyPluginUrl,
  currentEnvironment,
  gamGptScriptUrl,
  gamNetworkId,
  gamParentAdUnitId,
  gamCurrentMicroserviceS1Id,
  gamTestAdContainerId,
  userEmailDomainCookieKey,
  ctaPrivacyUrl,
  ctaTermsUrl,
  osfScriptUrl,
  applicationReleaseNumber,
  serviceName,
  dataDogBrowserSampleRate,
  dataDogTraceSampleRate,
  dataDogApplicationId,
  dataDogClientToken,
  dataDogEnabled,
  dataDogAllowedTracingOrigin,
  enableNonPremiumFeatures,
  salesForceProxyApiUrl,
  sfmcProPlusFormId,
  environment,
  debugVersion,
  ldJsonLogoUrl,
  fontCSSUrl,
  defaultShareUrl,
};

module.exports = config;
